import { combineReducers } from 'redux';
import * as ActionsTypes from '../actions/types';
import applicationUser from './applicationUser';
import question from './question';
import questionType from './questionType';
import claimType from './claimType';
import questionGroupStep from './questionGroupStep';
import claimCategory from './claimCatgegory';
import policyType from './policyType';
import answer from './answer';
import questionValidationRule from './questionValidationRule';
import claimApplication from './claimApplication';
import documentType from './documentType';
import applicationSettings from './applicationSettings';
import message from './message';
import communicatorMessage from './communicatorMessage';
import claimReview from './claimReview';
import claimDocument from './claimDocument';
import formType from './formType';
import survey from './survey';
import currency from './currency';

const reducers = combineReducers({
    communicatorMessage,
    message,
    applicationSettings,
    documentType,
    claimCategory,
    questionGroupStep,
    claimType,
    questionType,
    question,
    applicationUser,
    policyType,
    answer,
    questionValidationRule,
    claimApplication,
    claimReview,
    claimDocument,
    formType,
    survey,
    currency,
});

const resettableRootReducer = (state, action) => {
    if (action.type === ActionsTypes.LOGOUT) {
        return reducers(undefined, action);
    }
    return reducers(state, action);
};

export default resettableRootReducer;
